/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

/**
 * Ecsper custom XML part constants.
 *
 * Source: ECS-DD-MS365-001 v1.0.0 SS B4.8 (custom XML part definition)
 */

/** Custom XML namespace URI */
export const ECSPER_DOCUMENT_NAMESPACE = 'urn:ecsper:document:1';

/** Custom XML part path within the DOCX package */
export const ECSPER_XML_PART_PATH = '/customXml/item-ecsper-doc.xml';

/** Current schema version for new documents */
export const CURRENT_SCHEMA_VERSION = '1.0.0';
